import API_KEY from "../../api";

export const products = {
  getProducts: async (store, payload) => {
    const { params } = payload;
    store.setState({ loading: true });
    const data = await API_KEY.URL.get(API_KEY.path.products, { params });
    console.log(data.data, "products");
    store.setState({ products: data?.data, loading: false });
  },
  getProductsFilters: async (store, filters, fields, search_query) => {
    store.setState({ loading: true });
    const data = await API_KEY.URL.get(API_KEY.path.products, {
      params: {
        filter: filters
          ? filters
          : {
              user_id: {
                _eq: `$CURRENT_USER`,
              },
            },
        fields: fields,
        meta: "total_count,filter_count",
        search: search_query,
      },
    });
    store.setState({ products: data?.data, loading: false });
  },
  selectedProduct: async (store, payload) => {
    store.setState({ selectedProdutcs: payload, loading: false });
  },
  setProductIndex: async (store, payload) => {
    store.setState({ productIndex: payload });
  },
  setWishlistComments: async (store, payload) => {
    store.setState({ wishlistComments: payload });
  },
  setPlpScrollPosition: async (store, payload) => {
    store.setState({
      plpScrollPosition: payload,
    });
  },
  setFetchedStates: (
    store,
    {
      products = null,
      filters = null,
      quickFilters = null,
      facets = null,
      productCount = null,
      nbPages = null,
      hasMore = null,
      page = null,
    }
  ) => {
    if (products !== null) store.setState({ fetchedProducts: products });
    if (filters !== null) store.setState({ fetchedFilters: filters });
    if (quickFilters !== null)
      store.setState({ fetchedQuickFilters: quickFilters });
    if (facets !== null) store.setState({ fetchedFacets: facets });
    if (productCount !== null)
      store.setState({ fetchedProductCount: productCount });
    if (nbPages !== null) store.setState({ fetchedNbPages: nbPages });
    if (hasMore !== null) store.setState({ fetchedHasMore: hasMore });
    if (page !== null) store.setState({ fetchedPage: page });
  },
};
